import React from "react";
import classNames from 'classnames';
import ProgressBar from "components/ProgressBar";
import css from "./style.scss";

import CheckCircle from "assets/images/check-circle-Teal.svg";
import CheckCircleInactive from "assets/images/check-circle-inactive.svg";

const CampaignDetails = ({
  contactedLeadsCount,
  totalLeadsCount,
  progressPercent,
  status,
  dialerCampaignLeads,
  dialerCampaignInactive,
  onLeadsTableScroll,
  getAddressText,
  formatPhoneNumber,
  allNonSkipTraced,
  leadsTableRef,
  currentLeadIndex,
  onLeadClick
}) => {
  return (
    <div className={classNames(css.campaignDetails, { [css.allNonSkipTraced]: allNonSkipTraced })}>
      <div className={css.leadsSummary}>
        <div className={css.leadsSummaryText}>
          {contactedLeadsCount} of {totalLeadsCount} Leads Contacted
        </div>

        <ProgressBar
          percent={progressPercent}
          inactive={status === "CANCELLED"}
        />
      </div>

      {dialerCampaignLeads?.leads ? (
        <div ref={leadsTableRef} className={classNames(css.leadsTable, { [css.allNonSkipTraced]: allNonSkipTraced })} onScroll={onLeadsTableScroll}>
          <table className={css.table}>
            <thead>
              <tr>
                <th>#</th>
                <th>Contact Name</th>
                <th>Address</th>
                <th>Phone Numbers</th>
                <th className={css.contactedHeader}>Contacted</th>
              </tr>
            </thead>

            <tbody>
              {dialerCampaignLeads.leads.map((lead, index) => (
                <tr
                  className={classNames((onLeadClick ? css.tableRowRowNavigation : null), (index == currentLeadIndex ? css.currentLeadViewed : null))}
                  key={lead.contactInfo?.id}
                  onClick={() => onLeadClick && onLeadClick(index)}
                >
                  <td>
                    {dialerCampaignLeads.pageSize *
                      (dialerCampaignLeads.page - 1) +
                      (index + 1)}
                  </td>

                  <td>{lead.contactInfo?.name}</td>

                  <td className={css.address}>{getAddressText(lead)}</td>

                  <td>
                    <div className={css.phoneNumbers}>
                      {lead.contactInfo?.phoneNumbers
                        ? lead.contactInfo.phoneNumbers
                            .map((item) => formatPhoneNumber(item.phoneNumber))
                            .join(", ")
                        : null}
                    </div>
                  </td>

                  <td className={css.contacted}>
                    {lead.contactInfo?.contacted ? (
                      !dialerCampaignInactive ? (
                        <img src={CheckCircle} alt="CheckCircle" />
                      ) : (
                        <img
                          src={CheckCircleInactive}
                          alt="CheckCircleInactive"
                        />
                      )
                    ) : null}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
};

export default CampaignDetails;
